/* DeviceActionsComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./DeviceActionsRenderer");
const _ = require("lodash");

class DeviceActionsColumnComponent extends DefaultColumnComponent {
    constructor(configOptions, context) {
        super(configOptions, context);
        // console.log(configOptions.id, configOptions.description, configOptions.isStableDeviceConfiguration);
        if (!configOptions.isStableDeviceConfiguration) {
            this._delete = true;
            this._defaultSnapshot = true;
        } else {
            this._delete = false;
            this._defaultSnapshot = false;
        }

        this._context = context;
        this._isRestoreRunAvailable = _.get(this._context, "isRestoreRunAvailable", false);
        this._isOsSupported = _.get(this._context, "isOsSupported", false);

        this._isRestoreRunEnabled = !!_.get(
            configOptions,
            "pristineProperties.backupConfigurationId",
            false
        );

        this._edit = true;
        this._rollback = false;
        this._view = true;
        this._compare = true;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._defaultSnapshot = undefined;
            this._renderer = undefined;
            this._edit = undefined;
            this._rollback = undefined;
            this._view = undefined;
            this._compare = undefined;
            this._delete = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _triggerUserCellAction(eventData) {
        this.emit("UserCellAction", eventData);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.defaultSnapshot)) {
            this.setDefaultSnapshot(newVal.defaultSnapshot);
        }
        if (!_.isUndefined(newVal.edit)) {
            this.setEdit(newVal.edit);
        }
        if (!_.isUndefined(newVal.rollback)) {
            this.setRollback(newVal.rollback);
        }
        if (!_.isUndefined(newVal.view)) {
            this.setView(newVal.view);
        }
        if (!_.isUndefined(newVal.compare)) {
            this.setCompare(newVal.compare);
        }
        if (!_.isUndefined(newVal.delete)) {
            this.setDelete(newVal.delete);
        }
    }
    getValue() {
        return {
            defaultSnapshot: this.getDefaultSnapshot(),
            edit: this.getEdit(),
            rollback: this.getRollback(),
            view: this.getView(),
            compare: this.getCompare(),
            restore: this.getRestore(),
            delete: this.getDelete(),
        };
    }

    setDefaultSnapshot(newVal) {
        this._defaultSnapshot = newVal;
        this.emit("DefaultSnapshot", newVal);
        return this;
    }
    getDefaultSnapshot() {
        return this._defaultSnapshot;
    }

    setEdit(newVal) {
        this._edit = newVal;
        this.emit("Edit", newVal);
        return this;
    }
    getEdit() {
        return this._edit;
    }

    setRollback(newVal) {
        this._rollback = newVal;
        this.emit("Rollback", newVal);
        return this;
    }
    getRollback() {
        return this._rollback;
    }

    setView(newVal) {
        this._view = newVal;
        this.emit("View", newVal);
        return this;
    }
    getView() {
        return this._view;
    }

    setCompare(newVal) {
        this._compare = newVal;
        this.emit("Compare", newVal);
        return this;
    }
    getCompare() {
        return this._compare;
    }

    getRestore() {
        return this._isRestoreRunEnabled;
    }

    setDelete(newVal) {
        this._delete = newVal;
        this.emit("Delete", newVal);
        return this;
    }
    getDelete() {
        return this._delete;
    }

    static SortFunction(a, b) {
        let aVal = 0,
            bVal = 0;

        if (a[1].defaultSnapshot === true) {
            aVal++;
        }
        if (a[1].edit === true) {
            aVal++;
        }
        if (a[1].rollback === true) {
            aVal++;
        }
        if (a[1].view === true) {
            aVal++;
        }
        if (a[1].compare === true) {
            aVal++;
        }
        if (a[1].delete === true) {
            aVal++;
        }
        if (b[1].defaultSnapshot === true) {
            bVal++;
        }
        if (b[1].edit === true) {
            bVal++;
        }
        if (b[1].rollback === true) {
            bVal++;
        }
        if (b[1].view === true) {
            bVal++;
        }
        if (b[1].compare === true) {
            bVal++;
        }
        if (b[1].delete === true) {
            bVal++;
        }

        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DeviceActionsColumnComponent;
